<template>
  <div>
    <v-dialog v-model="dialog" max-width="900px">
      <v-card dark>
        <v-card-title class="mb-0 pb-0">
          <span class="headline mb-0 pb-0 ml-4 mt-3 font-weight-light"
            >Merge into other Contact before deleting</span
          >
        </v-card-title>
        <v-card-text class="mt-0 pt-0">
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12>
                <div class="title mb-2">Contacts to delete:</div>
                <div
                  v-for="c in selected"
                  :key="c.id"
                  style="color:red; font-size: 17px;"
                >
                  {{ c.name }}
                  <span class="right">ID-{{ c.id }}</span>
                </div>
              </v-flex>
              <v-flex xs12 mt-3 v-if="artworks.length > 0">
                <b>Affected Artworks:</b>
                <div style="color:white; font-size:17px;">
                  <div v-for="a in artworks" :key="a.id">
                    <b>{{ a.accession_number }}</b>
                    - {{ a.name }} - {{ a.title }}
                  </div>
                </div>
              </v-flex>
              <v-flex v-else mt-3>
                <b>NO ARTWORKS HAVE THIS CONTACT AS ACQUISITION SOURCE</b>
              </v-flex>

              <v-flex xs12 v-if="artworks.length > 0">
                <v-flex>
                  <div class="title mt-4">
                    Select Contact to set new Acquisition Source to artworks
                    below:
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    v-model="selectedContact"
                    @change="setContact2"
                    :items="table_contacts"
                    item-text="name"
                    item-value="id"
                    label
                  >
                    <template v-slot:item="data">
                      <v-list-tile-content class="py-2">
                        <v-list-tile-title
                          v-html="data.item.name"
                        ></v-list-tile-title>
                        <v-list-tile-sub-title
                          v-html="`Atworks Count: ${data.item.artworks.length}`"
                        ></v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action
                        >ID-{{ data.item.id }}</v-list-tile-action
                      >
                    </template>
                  </v-autocomplete>
                </v-flex>

                <!-- <v-flex xs12 v-if="contact2">
                  <b
                    ><u>{{ contact2.name }}</u></b
                ><span class="right">ID-{{ contact2.id }}</span>-->
                <!-- / {{contact2.first_name}} / {{contact2.last_name}} / {{contact2.company}}</b> -->
                <!-- </v-flex> -->
                <v-flex xs12 v-if="artworks2.length > 0">
                  <b>Current Artworks af this Contact:</b>
                  <ul>
                    <li v-for="a in artworks2" :key="a.id">
                      {{ a.accession_number }} / {{ a.name }} / {{ a.title }}
                    </li>
                  </ul>
                </v-flex>
                <v-flex v-else>
                  <b>NO ARTWORKS</b>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="pr-4 pb-4">
          <v-spacer></v-spacer>
          <v-btn color="blue" flat @click="dialog = false">Close</v-btn>
          <v-btn color="red" flat @click="deleteContact2" v-if="c_user.delete_rights">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card class="mx-0 px-0 elevation-0">
      <v-card-title>
        <!-- <v-btn @click="clear_selection" v-if="this.selected.length>0">CLEAR SELECTION</v-btn>
        <v-btn @click="select_all">SELECT ALL</v-btn>-->
        <v-btn 
          class="mx-0 mb-0"
          small
          v-if="selected.length > 0 && c_user.delete_rights"
          color="red"
          @click="deleteContacts"
          dark
          >Delete Contacts</v-btn
        >
        <v-btn
          class="mx-3 mb-0"
          small
          v-if="selected.length > 0 && c_user.delete_rights"
          color="black"
          @click="resetSelected"
          dark
          >Clear Selection</v-btn
        >

        <v-layout row my-3 mx-1>
          <span>
            <v-menu
              offset-y
              :close-on-content-click="true"
              class="text-xs-right mx-4 my-0 py-0 align-center"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  icon
                  color="black"
                  dark
                  v-on="on"
                  class="text-xs-right mx-0 mt-2 my-0 py-0"
                >
                  <v-icon small>supervisor_account</v-icon>
                </v-btn>
              </template>
              <v-list value="2">
                <v-list-tile
                  v-for="(item, index) in ownerships"
                  :key="index.id"
                  @click="toggleOwnership(item)"
                >
                  <!-- <v-list-tile-avatar v-if="item.id==sorting">
                    <v-icon>mdi-sort-ascending</v-icon>
                  </v-list-tile-avatar> -->
                  <!-- <v-list-tile-avatar v-else>
                    <v-icon></v-icon>
                  </v-list-tile-avatar> -->
                  <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </span>
          <span class="text-xs-left mt-2 pt-1 title">
            {{ selectedOwnership }}
          </span>
          <v-spacer></v-spacer>
        </v-layout>

        <v-spacer></v-spacer>

        <v-btn
          small dark
          color="black"
          class="mr-3 mt-3"
          @click="exportToExcel"
        >
          <v-icon small left>mdi-file-excel</v-icon>
          Export to Excel
        </v-btn>

        <v-text-field
          v-if="this.$store.state.showSearch"
          class="mr-3"
          prepend-inner-icon="search"
          label="Search "
          single-line
          clearable
          hide-details
          v-model="search"
        ></v-text-field>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="contacts"
        :search="search"
        style="border-top: 1px solid #ccc"
        hide-headers
        :pagination.sync="pagination"
        v-model="selected"
        item-key="id"
        must-sort
        :loading="$store.state.loading_contacts"
        rows-per-page-text="Contacts per page"
        no-results-text="No Contacts match the criteria."
        class="elevation-0 mx-4"
        :rows-per-page-items="[10, 20, 30]"
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td style="width:15px; padding:0px; margin:0px;">
              <v-checkbox
                color="black"
                primary
                hide-details
                v-model="props.selected"
              ></v-checkbox>
              <!-- @change="save_currently_selected(props.selected,props.item)" -->
            </td>
            <td class="title font-weight-light py-3">
              <router-link :to="{ name: 'EditContact', params: {id: props.item.id, contact: props.item}, path: `/contacts/edit/${props.item.id}`}">
              {{ props.item.name }}
              </router-link>
            </td>
            <td>{{ props.item.company }}</td>
            <td>
              <!-- {{ props.item.category == "acquisition_source" ? "A.S." : "" }} -->
              {{ props.item.category == "artwork_acquisition_source" ? "A.S." : "" }}
              {{ props.item.category == "registrar" ? "R" : "" }}
              {{ props.item.category == "exhibition_institution" ? "E.I" : "" }}
            </td>
            <td>{{ props.item.artworks.length }}</td>
            <!-- <td align="right" style="width:80px; padding:0px; margin:0px;"> -->
              <!-- <v-btn
                class="px-0 mx-0"
                small
                icon
                @click="
                  $router.push({
                    name: 'EditContact',
                    params: { id: props.item.id, contact: props.item },
                    path: `/contacts/edit/${props.item.id}`
                  })
                "
              >
                <v-icon color="black" small>edit</v-icon>
              </v-btn> -->
              <!-- <v-btn v-if="c_user.delete_rights"
                small
                icon
                @click="deleteContact(props.item)"
                class="px-0 mx-2"
              >
                <v-icon color="black" small>delete</v-icon>
              </v-btn>
            </td> -->
            <!-- <td class="text-xs-center" style="width:30px;">{{ props.item.accession_number }}</td>
            <td class="text-xs-center" style="width:30px;">{{ props.item.classification }}</td>-->
            <!-- <td class="text-xs-right">
              <router-link style="padding-left:10px;" :to="{ name: 'EditContact', params: {id: props.item.id, contact: props.item}, path: `/contacts/edit/${props.item.id}`}" >
              <v-btn icon><v-icon>edit</v-icon></v-btn>
              </router-link>
            </td>-->
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
        <template slot="no-data">
          <index-load-state
            :loading="$store.state.loading_contacts"
            :error="$store.state.load_errors.contacts"
            empty-text="No Contacts Found."
          ></index-load-state>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from '@/utils/apiClient';
import { serverBus } from "../../main";
import XLSX from 'xlsx'
import IndexLoadState from '@/components/general/IndexLoadState.vue'
export default {
  components: { IndexLoadState },
  created: function() {
    this.$store.dispatch("loadContacts");
    this.contacts = this.$store.state.contacts;
    this.ownerships = Object.assign([], this.$store.getters.my_ownerships);
    this.ownerships.unshift({id: 'all', name: 'All'})
    // this.initialize();
    // this.filtered = this.exhibitions;
    serverBus.$on("setSorting", a => {
      // console.log('receive')
      // console.log(a)
      this.pagination.sortBy = a;
      this.pagination.descending = !this.pagination.descending;
    });
    this.toggleOwnership(this.$store.state.filters['contacts'] ? this.$store.state.filters['contacts'] : this.ownerships[0])
    // this.toggleOwnership(this.ownerships[0]);
  },
  data() {
    return {
      dialog: false,
      ownerships: [],
      contacts: [],
      selectedOwnership: '',
      contact: "",
      contact2: {},
      selectedContact: "",
      artworks: [],
      artworks2: [],
      show_tag_filter: false,
      show_classifications: false,
      filter: {
        selected_classifications: [],
        selected_classification_negations: []
      },
      ta: [],
      selected_tags: [],
      selected_categories: [],
      selected: [],
      search: "",
      pagination: {
        rowsPerPage: 15,
        sortBy: "name"
      },
      headers: [
        { sortable: false },
        { text: "Name", value: "name", align: "left" },
        { text: "Company", value: "company", align: "left" },
        { text: "Category", value: "category", align: "left" },
        { text: "Artworks", value: "artworks.length", align: "left" },
        // { text: "", align: "right", sortable: false }
      ]
    };
  },
  props: ["items"],
  methods: {
    exportToExcel() {
      // Prepare data for export
      const data = this.contacts.map(contact => ({
        'Name': contact.name,
        'Company': contact.company,
        'Category': contact.category,
        'Artworks': contact.artworks && contact.artworks.length ? contact.artworks.map(a => {
          const artwork = this.$store.state.artworks.find(b => b.id == a.id);
          return artwork ? '[' + artwork.accession_number + ': ' + artwork.title + ']' : 'Not set';
        }).join(', ') : ''
      }))

      // Create worksheet
      const ws = XLSX.utils.json_to_sheet(data)
      
      // Create workbook
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Contacts')
      
      // Generate Excel file
      XLSX.writeFile(wb, `contacts_${new Date().toISOString().split('T')[0]}.xlsx`)
    },
    toggleOwnership(o) {
      // this.selectedOwnership = o;
      // if(this.selectedOwnership.id != 'all') {
      //   // console.log('not all')
      //   this.contacts = this.table_contacts.filter(c =>
      //     c.artworks.some(
      //       ca => ca.ownership == this.selectedOwnership.id
      //     )
      //   );
      // } else {
      //   this.contacts = this.table_contacts;
      // }
      this.$store.dispatch('setFilter', { section: 'contacts', ownership: o })

      this.selectedOwnership = o.name;
      if(o.id != 'all') {
        this.contacts = this.table_contacts.filter(a =>
          a.artworks.some(
            ea => ea.ownership == o.id
          )
        );
      } else {
        this.contacts = this.table_contacts;
      }
      // return this.$store.state.contacts.filter(
      //   c =>
      //     c.category == "artwork_acquisition_source" ||
      //     c.category == "registrar"
      // );

      // var array = [];
      // for (var i in ownerships) {
      //   // array.push(i);
      //   array.push(ownerships[i]);
      // }
      // console.log(array);
      // console.log(this.ownerships);
      // console.log(array.indexOf(this.s_ownership));
      // console.log(this.s_ownership);
      // console.log(this.ownerships.indexOf(this.s_ownership));
      // this.selectedOwnership = o.name;
      // if(o.id != 'all') {
      //   this.contacts = this.table_contacts.filter(a =>
      //     a.artworks.some(
      //       ea => ea.ownership == o.id
      //     )
      //   );
      // } else {
      //   this.contacts = this.table_contacts;
      // }
    },    
    resetSelected() {
      this.selected = [];
      this.artworks = [];
      this.artworks2 = [];
    },
    setContact2() {
      this.contact2 = this.$store.state.contacts.find(
        c => c.id === this.selectedContact
      );
      this.artworks2 = this.$store.state.artworks.filter(
        a => a.acquisition_source_id === this.contact2.id
      );
    },
    deleteContact(c) {
      this.selected = [];
      this.selected.push(c);
      this.dialog = true;
      this.contact = c;
      this.artworks = this.$store.state.artworks.filter(
        a => c.id == a.acquisition_source_id
      );
    },
    deleteContacts() {
      this.dialog = true;
      // this.contact = c;
      this.artworks = this.$store.state.artworks.filter(a =>
        this.selected.map(a => a.id).includes(a.acquisition_source_id)
      );
    },
    deleteContact2() {
      this.artworks.forEach(c => {
        // console.log(c);
        this.$emit("showSnackbar", "Deleting Contact: " + c.title);
        setTimeout(() => {
          let url = `${this.$globals.apiserver}/artworks/${c.id}.json`;
          // console.log("updating artwork start");
          // console.log(url);
          // console.log(this.selectedContact);
          // console.log("updating artwork end");
          axios
            .put(url, {
              field_name: "acquisition_source_id",
              field_value: this.selectedContact,
              updated_by: this.c_user.id
            })
            .then(response => {
              this.$emit(
                "showSnackbar",
                "Saved Artwork's Acquisition Source",
                "green"
              );
              this.progress = false;
              this.isEditing = false;

              this.$store.dispatch("loadContacts");
              this.$store.dispatch("loadArtworks");
            })
            .catch(error => {
              this.$emit(
                "showSnackbar",
                "Error Saving Artwork's Acquisition Source",
                "red"
              );
              this.progress = false;
              this.isEditing = false;
            });
        }, 1000);
      });

      this.selected.forEach(c => {
        this.$emit("showSnackbar", "Deleting Contact: " + c.name);
        setTimeout(() => {
          let url = `${this.$globals.apiserver}/contacts/${c.id}.json`;
          // console.log("deleting contact start");
          // console.log(url);
          // console.log(c);
          // console.log("deleting contact end");
          axios
            .delete(url)
            .then(response => {
              this.$emit("showSnackbar", "Deleted " + c.name, "green");
              this.progress = false;
              this.isEditing = false;

              this.$store.dispatch("loadContacts");
              this.$store.dispatch("loadArtworks");
            })
            .catch(error => {
              this.$emit("showSnackbar", "Error Deleting " + c.name, "red");
              this.progress = false;
              this.isEditing = false;
            });
        }, 1000);
      });

      this.dialog = false;
      this.contact = "";
      this.artworks = [];
      this.artworks2 = [];
      this.selected = [];
    }
  },
  computed: {
    // artworks2() {
    //   return this.$store.state.artworks.filter(
    //     (a) => a.acquisition_source_id === this.contact2.id
    //   );
    // },
    table_contacts() {
      // if (this.contacts && this.contacts.length > 0) {
      //   return this.$store.state.contacts.filter(
      //     c =>
      //       (c.category == "artwork_acquisition_source" ||
      //         c.category == "registrar") &&
      //       this.contacts.includes(contact2)
      //   );
      // } else {

      // this.selectedOwnership = o.name;
      // if(this.selectedOwnership.id != 'all') {
      //   this.contacts = this.contacts.filter(a =>
      //     a.artworks.some(
      //       ea => ea.ownership == this.selectedOwnership.id
      //     )
      //   );
      // } else {
      //   this.contacts = this.contacts;
      // }

      return this.$store.state.contacts.filter(
        c =>
          c.category == "artwork_acquisition_source" ||
          c.category == "registrar" ||
          c.category == "exhibition_institution" 
      );
      // }
    }
  }
};
// if (this.selected_categories.length > 0) {
//   var cst = this.selected_categories
//   var a = this.$store.state.contacts.filter(function(contact) {
//     return cst.indexOf(contact.category) > -1
//   })
//   return this.$store.state.contacts.filter(function(contact) {
//     return cst.indexOf(contact.category) > -1
//   })
// } else {
//   return this.items
// }
// currrent_path() {
//   return this.$route.params.ownership;
// },
// saved_lists() {
//   return [
//     { id: 1, title: "list1" },
//     { id: 2, title: "list2" },
//   ];
// },
// selected_contacts() {
//   return this.$store.state.currentSelection;
// },
// tagged_contacts() {
//   var cst = this.$store.state.currentSelectionTags;
//   return this.table_contacts.filter(function (contact) {
//     return contact.tags.some((a_tag) => cst.indexOf(a_tag.id) > -1);
//   });
// },
// select_categories() {
//   var stc = this.selected_tag_categories;
//   var tc = this.tag_categories;
//   var tags = Object.assign([], this.$store.state.tags);
//   var out = [];
//   // console.log(tags)
//   tags.forEach((tag) => {
//     var a = tc.filter(function (tagc) {
//       return tagc.id == tag.tag_category_id;
//     });
//     // console.log(a[0].color)
//     tag.color = a[0].color;
//     out.push(tag);
//   });
//   // console.log(out)
//   return out.filter(function (tag) {
//     return stc.some((st) => tag.tag_category_id == st);
//   });
// },
// switchSwitch() {
//   // this.show_tag_filter = !this.show_tag_filter
//   this.$emit("switchOwnershipTop", this.show_tag_filter);
// },
// clearFilters() {
//   this.selected_tags = [];
//   this.selected_tag_categories = [];
// },
// clear_selection() {
//   this.$store.dispatch("clearCurrentSelection");
//   this.selected = [];
// },
// select_all() {
//   this.selected = this.table_contacts;
//   var temp_selection = Object.assign(
//     [],
//     this.$store.state.currentSelection
//   );
//   this.table_contacts.forEach((a) => {
//     if (!temp_selection.includes(a)) {
//       temp_selection.push(a);
//     }
//   });
//   this.$store.dispatch("saveCurrentSelection", temp_selection);
// },
// save_selection() {
//   this.$store.dispatch("clearCurrentSelection");
// },
// save_currently_selected(a, b) {
//   setTimeout(
//     function () {
//       var temp_selection = Object.assign(
//         [],
//         this.$store.state.currentSelection
//       );
//       //// console.log(temp_selection)
//       if (!a) {
//         // console.log('a true')
//         if (!temp_selection.includes(b)) {
//           // console.log('doesnt include')
//           temp_selection.push(b);
//         }
//       } else {
//         // console.log('false')
//         var index = temp_selection.indexOf(b);
//         // console.log('index = ' + index)
//         temp_selection.splice(index, 1);
//       }
//       this.$store.dispatch("saveCurrentSelection", temp_selection);
//     }.bind(this),
//     1000
//   );
// },
// save_currently_selected_all(a) {
//   // console.log('///////////')
//   // console.log('a = ' + a)
//   var temp_selection = Object.assign(
//     [],
//     this.$store.state.currentSelection
//   );
//   // console.log(temp_selection)
//   if (!a) {
//     // console.log('a true')
//     if (!temp_selection.includes(b)) {
//       // console.log('doesnt include')
//       temp_selection.push(b);
//     }
//   } else {
//     // console.log('false')
//     var index = temp_selection.indexOf(b);
//     // console.log('index = ' + index)
//     temp_selection.splice(index, 1);
//   }
//   // this.$store.state.currentSelection
//   // console.log(temp_selection)
//   // this.selected.forEach(s => {
//   //   if (!temp_selection.includes(s)) {
//   //     temp_selection.push(s)
//   //   }
//   // })
//   // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
//   this.$store.dispatch("saveCurrentSelection", temp_selection);
// },
// save_currently_selected_tags() {
//   this.$store.dispatch("saveCurrentSelectionTags", this.selected_tags);
//   this.ta = this.tagged_contacts;
// },
// contact_categories: [
//   { id: 1, name: "loan_borrower", color: "red", position: 2 },
//   { id: 3, name: "loan_contact_person", color: "blue", position: 1 },
//   { id: 7, name: "loan_insurance_company", color: "purple", position: 7 },
//   {
//     id: 2,
//     name: "artwork_acquisition_source",
//     color: "green",
//     position: 3,
//   },
//   { id: 4, name: "registrar", color: "yellow", position: 4 },
//   { id: 5, name: "staff", color: "pink", position: 5 },
//   {
//     id: 6,
//     name: "device_acquisition_company",
//     color: "grey",
//     position: 6,
//   },
//   { id: 8, name: "staff_external", color: "grey", position: 8 },
//   { id: 9, name: "trustee", color: "grey", position: 9 },
// ],
</script>

<style scoped>
/* td {height: 120px !important;} */
a {
  text-decoration: none;
}
</style>
<!-- <v-card class="my-3">
      <v-switch v-model="show_tag_filter" @change="switchSwitch" label="Show Filters" class="py-3 ml-4" hide-details></v-switch>
      <v-card-text v-if="show_tag_filter">
        <v-btn @click="clearFilters">Reset Filters</v-btn>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12 sm6 md3 v-for="tc in this.contact_categories" v-bind:key="tc.id">
              <v-checkbox small 
                v-model="selected_categories"
                v-bind:label="tc.name"
                v-bind:value="tc.name"
                v-bind:color="tc.color"
                hide-details
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>-->



// WEBPACK FOOTER //
// src/components/contacts/ContactsTable.vue